import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { createDynamicMiddlewares } from 'redux-dynamic-middlewares';
import modalReducer from './wrappers/Modal/modalSlice.js';
import stepModalReducer from './wrappers/StepModal/stepModalSlice.js';
import inlineFormReducer from './wrappers/InlineForm/inlineFormSlice.js';
import loginReducer from '../views/Login/loginSlice.js';
import registrationReducer from '../views/Registration/registrationSlice.js';
import resetPasswordReducer from '../views/ResetPassword/resetPasswordSlice.js';
import passwordlessReducer from './features/passwordless/passwordlessSlice.js';
import loginWithAppleReducer from './features/loginWithApple/loginWithAppleSlice.js';
import siteConfigReducer from './core/siteConfig/siteConfigSlice.js';
import sourceDataReducer from './core/sourceData/sourceDataSlice.js';
import navigationReducer from './core/navigation/navigationSlice.js';
import consentReducer from './core/consent/consentSlice.js';
import experimentsReducer from './core/experiments/experimentsSlice.js';
import authSuccessReducer from './core/authSuccess/authSuccessSlice.js';
import authErrorReducer from './core/authError/authErrorSlice.js';
import wrapperContextReducer from './core/wrapperContext/wrapperContextSlice.js';
import accountIdentifierReducer from '../views/AccountIdentifier/accountIdentifierSlice.js';
import appleUpdateEmailReducer from '../views/AppleUpdateEmail/appleUpdateEmailSlice.js';
import loginWithLinkedInReducer from './features/loginWithLinkedIn/loginWithLinkedInSlice.js';
// we need external library to use dynamicMiddleware in @reduxjs/toolkit < 2, to remove after upgrade
// redux-toolkit downgrade due to memory leak in nextjs, most probably here
// https://github.com/reduxjs/redux-toolkit/issues/3988#issuecomment-1865284164
export const dynamicMiddleware = createDynamicMiddlewares();
const wrappersReducer = combineReducers({
    modal: modalReducer,
    inlineForm: inlineFormReducer,
    stepModal: stepModalReducer,
});
const formsReducer = combineReducers({
    login: loginReducer,
    registration: registrationReducer,
    resetPassword: resetPasswordReducer,
    accountIdentifier: accountIdentifierReducer,
    appleUpdateEmail: appleUpdateEmailReducer,
});
const coreReducer = combineReducers({
    siteConfig: siteConfigReducer,
    sourceData: sourceDataReducer,
    consent: consentReducer,
    navigation: navigationReducer,
    experiments: experimentsReducer,
    authSuccess: authSuccessReducer,
    authError: authErrorReducer,
    wrapperContext: wrapperContextReducer,
});
const featuresReducer = combineReducers({
    loginWithApple: loginWithAppleReducer,
    loginWithLinkedIn: loginWithLinkedInReducer,
    passwordless: passwordlessReducer,
});
export const rootReducer = combineReducers({
    wrappers: wrappersReducer,
    features: featuresReducer,
    forms: formsReducer,
    core: coreReducer,
});
export const store = (preloadedState) => {
    return configureStore({
        reducer: rootReducer,
        preloadedState,
        middleware: (getDefaultMiddleware) => getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: ['sourceData/updateCallbackFunction'],
                ignoredPaths: ['core.sourceData.callbackFunction'],
            },
        }).prepend(dynamicMiddleware.enhancer),
    });
};
//# sourceMappingURL=index.js.map